<template>
  <v-container
    id="wizard"
    tag="section"
  >
    <base-material-wizard-site
      v-model="tab"
      :available-steps="availableSteps"
      :items="tabs"
      class="mx-auto"
      @click:next="next"
      @click:prev="tab--"
    >
      <v-tab-item class="pb-12">
        <v-form
          ref="form1"
        >
          <div class="text-center display-1 font-weight-dark mb-6">
            Set New Deposit Ids. Only sites with assigned safes are available
          </div>

          <v-row
            class="mx-auto"
            justify="space-around"
            style="max-width: 700px;"
          >
            <v-col
              cols="auto"
              class="text-center"
            >
              <v-card
                :class="sitename ? 'success--text' : 'grey--text'"
                class="mx-auto mt-0 d-inline-flex v-card--account"
                outlined
                height="106"
                width="106"
              >
                <v-icon
                  class="mx-auto"
                  size="100"
                >
                  mdi-home-plus
                </v-icon>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-autocomplete
                v-model="sitename"
                v-validate="'required'"
                :autocomplete="Date.now()"
                :error-messages="errors"
                :items="loadedsites"
                color="secondary"
                data-vv-name="sitename"
                label="Site Name*"
                validate-on-blur
                @change="onChange($event)"
              />
              <v-text-field
                v-model="safeid"
                readonly
                :rules="rules"
                color="secondary"
                label="Safe ID *"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-tab-item>

      <v-tab-item class="pb-12">
        <form
          action=""
          data-vv-scope="users"
        >
          <div class="text-center display-1 font-weight-dark mb-6">
            Add Default Users to this new safe.
          </div>

          <v-row
            class="mx-auto"
            justify="space-around"
            style="max-width: 700px;"
          >
            <v-col
              cols="auto"
              class="text-center"
            >
              <v-card
                :class="selected.length ? 'success--text' : 'grey--text'"
                class="mx-auto mt-0 d-inline-flex v-card--account"
                outlined
                height="106"
                width="106"
              >
                <v-icon
                  class="mx-auto"
                  size="82"
                >
                  mdi-account-multiple-plus
                </v-icon>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="8"
            >
              <v-data-table
                v-model="selected"
                :headers="userheader"
                :single-select="singleSelect"
                :items="defaultusers"
                item-key="pin"
                show-select
                hide-default-footer
              />
            </v-col>
          </v-row>
        </form>
      </v-tab-item>
      <v-tab-item class="pb-12">
        <form
          action=""
          data-vv-scope="users"
        >
          <div class="text-center display-1 font-weight-dark mb-6">
            Add Default Notifications to this new safe.
          </div>

          <v-row
            class="mx-auto"
            justify="space-around"
            style="max-width: 700px;"
          >
            <v-col
              cols="auto"
              class="text-center"
            >
              <v-card
                :class="alerts.length ? 'success--text' : 'grey--text'"
                class="mx-auto mt-0 d-inline-flex v-card--account"
                outlined
                height="106"
                width="106"
              >
                <v-icon
                  class="mx-auto"
                  size="82"
                >
                  mdi-email
                </v-icon>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="8"
            >
              <v-data-table
                v-model="alerts"
                :headers="alertsheader"
                :single-select="singleSelect"
                :items="defaultalerts"
                item-key="id"
                show-select
                hide-default-footer
              />
            </v-col>
          </v-row>
        </form>
      </v-tab-item>
      <v-tab-item class="pb-12">
        <div class="text-center display-2 black--text font-weight-light mb-6">
          Please review the summary of deposit users to add.
        </div>

        <form
          action=""
          data-vv-scope="summary"
        >
          <v-row
            class="mx-auto"
            justify="space-around"
            style="max-width: 700px;"
          >
            <v-col
              cols="auto"
              class="text-center"
            >
              <v-card
                :class="selected.length ? 'success--text' : 'grey--text'"
                class="mx-auto mt-0 d-inline-flex v-card--account"
                outlined
                height="106"
                width="106"
              >
                <v-icon
                  class="mx-auto"
                  size="96"
                >
                  mdi-home-plus
                </v-icon>
              </v-card>
            </v-col>

            <v-col
              cols="12"
              md="8"
            >
              <div class="display-1 black--text font-weight-light">
                Site Name: {{ sitename }} <br>
                Using safe UnitID: {{ safeid }} <br>
                Deposit Users: <br>
                <div
                  v-for="(user, i) in selected"
                  :key="i"
                >
                  {{ user.usertype }} {{ user.label }} PIN: {{ user.pin }}
                </div>
                Alerts: <br>
                <div
                  v-for="(alert, i) in alerts"
                  :key="i"
                >
                  {{ alert.alert }} {{ alert.email }}
                </div>
              </div>
            </v-col>
          </v-row>
        </form>
      </v-tab-item>
    </base-material-wizard-site>
  </v-container>
</template>

<script>
  export default {
    name: 'DashboardFormsWizard',
    data: () => ({
      safeid: '',
      sitename: '',
      assignedunit: '',
      userheader: [
        { text: 'User ID', align: 'center', value: 'label', sortable: false },
        { text: 'Type', align: 'center', value: 'usertype', sortable: false },
        { text: 'User PIN', align: 'center', value: 'pin', sortable: false },
      ],
      defaultusers: [
        { label: 'Manager 1', pin: 1111, usertype: 'Standard' },
        { label: 'Manager 2', pin: 2222, usertype: 'Standard' },
        { label: 'Manager 3', pin: 3333, usertype: 'Standard' },
        { label: 'Manager 4', pin: 4444, usertype: 'Standard' },
        { label: 'Manager 5', pin: 5555, usertype: 'Standard' },
        { label: 'Manager 6', pin: 6666, usertype: 'Standard' },
        { label: 'CIT 1', pin: 9898, usertype: 'Cit' },
      ],
      alertsheader: [
        { text: 'Alert Type', align: 'center', value: 'alert', sortable: false },
        { text: 'Destination', align: 'center', value: 'email', sortable: false },
      ],
      defaultalerts: [
        { id: 1, alert: 'User Deposit', email: 'jameskelly@ssarmored.com' },
        { id: 2, alert: 'End Of Day', email: 'jameskelly@ssarmored.com' },
        { id: 3, alert: 'End Of Day', email: 'Coin@ssarmored.com' },
      ],
      userslist: [],
      group: '',
      max: 50,
      allowSpaces: true,
      unique: true,
      filterchars: true,
      onlyspace: false,
      selected: [],
      alerts: [],
      singleSelect: false,
      loadedsites: '',
      sitenameRules: [
        v => !!v || 'Site name is required',
        v => (v && v.length <= 10) || 'Site name must be less than 10 characters',
      ],
      onboardEodTime: '',
      menueodtime: false,
      eodTime: 0,

      tab: 0,
      tabs: ['Site', 'Deposit User IDs', 'Notifications', 'Summary']
    }),
    computed: {
      rules () {
        const rules = []
        if (this.unique) {
          const rule =
            v => (!this.loadedsites.includes(v)) ||
              'Values must be unique and not be an existing site name'

          rules.push(rule)
        }
        if (!this.onlyspace) {
          const rule =
            v => v.trim().length || 'Name can not be only whitespace characters'

          rules.push(rule)
        }
        if (this.max) {
          const rule =
            v => (v || '').length <= this.max ||
              `A maximum of ${this.max} characters is allowed in a site name`

          rules.push(rule)
        }

        if (!this.allowSpaces) {
          const rule =
            v => (v || '').indexOf(' ') < 0 ||
              'No spaces are allowed'

          rules.push(rule)
        }
        if (this.filterchars) {
          const rule =
            v => !v.match(/\\t|[#\$\.]/gi) || ' $ # [ ] tabs are not allowed in a site name'
          rules.push(rule)
        }
        return rules
      },
      scope () {
        if (this.tab === 0) return 'new'
        else if (this.tab === 2) return 'summary'
        return 'safe'
      },
      grouplist () {
        // return []
        let groups = this.$store.getters.usergroups.map(
          group => group.name
        )
        return groups
      },
      allunits () {
        return this.$store.getters.ssunits.map(unit => unit.crypto_idnum)
      },
      getunassignedunits () {
        // get a list of profiles which are sites with safes assigned to them
        // get a list of all safe ids
        // return the list of unassigned safes
        let siteprofiles = this.$store.getters.loadedSiteProfiles
        let totalunits = this.$store.getters.ssunits
        let assignedsafes = []
        let sitenames = Object.keys(siteprofiles)
        for (let site of sitenames) {
          // console.log(site)
          if (siteprofiles[site].siteunitsprofile) {
            // console.log(siteprofiles[site].siteunitsprofile[0].crypto_idnum)
            if (siteprofiles[site].siteunitsprofile[0]) {
              assignedsafes.push(siteprofiles[site].siteunitsprofile[0].crypto_idnum)
            }
          }
        }
        let unassigned = totalunits.filter(unitrec => {
          if (!assignedsafes.includes(unitrec.crypto_idnum)) {
            return unitrec
          }
        })
        return unassigned.map(unit => unit.crypto_idnum)
      },
      availableSteps () {
        const steps = [0]

        if (this.sitename && this.safeid) { steps.push(1) }

        if (this.safeid && steps.includes(1)) steps.push(2)
        if (this.safeid && steps.includes(1) && steps.includes(2)) steps.push(3)
        if (
          this.safeid &&
          this.selected.length ||
          this.sitename &&
          steps.includes(2) &&
          steps.includes(3)
        ) steps.push(4)

        return steps
      }
    },
    watch: {
      sitename: 'validateField',
      max: 'validateField',
      model: 'validateField',
    },
    created () {
      this.$store.dispatch('loadSiteConfigs')
      this.$store.dispatch('loadunits')
      this.$store.dispatch('loadsiteProfiles')
      this.loadedsites = [...new Set(this.$store.getters.loadedSites.map(data => data.idnum))]
    },

    methods: {
      onChange (value) {
        this.$log.debug('value passed on change is ', value)
        this.siteunitsprofile
        this.loadedprofiles = this.$store.getters.loadedSiteProfiles
        this.$log.debug('loaded sites ', this.$store.getters.loadedSites)
        let site = this.$store.getters.loadedSites.filter(function (site) {
          return site.idnum === value
        })
        this.sitedetails = site[0]
        this.$log.debug('change to site ', this.sitedetails)
        let idnum = this.sitedetails.idnum
        // lets find that sites profile from the ones we loaded and show the tokens they want to offer clients to buy and sell
        if (this.loadedprofiles[idnum].siteunitsprofile) {
          this.assignedunit = this.loadedprofiles[idnum].siteunitsprofile[0]
          if (this.assignedunit) {
            this.safeid = this.assignedunit.crypto_idnum
          }
        }
      },
      validateField () {
        this.$refs.form1.validate()
      },
      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      next () {
        this.validateForm(this.scope).then(item => {
          if (!item) return
          if (this.tab === 0) {
          }

          if (this.tab === this.tabs.length - 1) {
            this.$validator.fields.items.forEach(f => {
              f.reset()
              f.name = ''
            })
            let serverpayload = []
            let notificationpayload = []
            this.selected.forEach(entry => {
              let rec = {
                safeid: this.assignedunit.crypto_idnum,
                siteid: this.sitename,
                username: entry.label,
                usertype: entry.usertype,
                userpin: entry.pin
              }
              serverpayload.push(rec)
            })
            this.$store.dispatch('addsafeuserbatchcmd', serverpayload)
            this.alerts.forEach(entry => {
              let rec = {
                crypto_idnum: this.assignedunit.crypto_idnum,
                siteid: this.sitename,
                label: 'default alert',
                method: 'EMAIL',
                event_type: entry.alert,
                destination: entry.email,
              }
              notificationpayload.push(rec)
            })
            this.$store.dispatch('addalertsbatchcmd', notificationpayload)

            this.safeid = null
            this.sitename = null
            this.selected = []
            this.tab = 0
            // call wizzard sitesetup
            // alert('The site has been added')
          } else {
            this.tab++
          }
        })
      },
      validateForm (scope) {
        return this.$validator.validateAll(scope)
      }
    }
  }
</script>

<style lang="sass">
  .v-card.v-card.v-card--account
    border-color: currentColor
    border-width: 4px

    .v-icon
      color: inherit

  .v-card--account,
  .v-card--account:before
    border-radius: 50%

</style>
